module.exports = __webpack_public_path__ + "static/media/check.3f3e16d9.svg";